import React, { useState, useRef, useEffect } from 'react'
import { SketchPicker, ColorResult } from 'react-color'
import cx from 'classnames'
import styles from './SketchColorPicker.module.css'

type SketchColorPickerProps = {
    property: string
    value: string
    onChange: (property: string, value: string) => void
    classes?: string
    children?: React.ReactNode
}

const SketchColorPicker: React.FC<SketchColorPickerProps> = ({
    property,
    value = '#ff0000',
    onChange,
    classes,
    children,
}) => {
    const [displayColorPicker, setDisplayColorPicker] = useState(false)
    const pickerRef = useRef<HTMLDivElement>(null)

    const handleClick = () => {
        setDisplayColorPicker(!displayColorPicker)
    }

    const handleClose = () => {
        setDisplayColorPicker(false)
    }

    const handleColorChange = (color: ColorResult) => {
        onChange(property, color.hex)
    }

    // Handle click outside to close picker
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (pickerRef.current && !pickerRef.current.contains(event.target as Node)) {
                setDisplayColorPicker(false)
            }
        }

        if (displayColorPicker) {
            document.addEventListener('mousedown', handleClickOutside)
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [displayColorPicker])

    return (
        <div className={cx(styles['color-picker-container'], classes)}>
            {children && (
                <div className={styles['color-picker-label']}>{children}</div>
            )}
            <div className={styles['color-picker-wrapper']}>
                <div className={styles['swatch']} onClick={handleClick}>
                    <div
                        className={styles['color']}
                        style={{ background: value }}
                    />
                </div>
                {displayColorPicker ? (
                    <div ref={pickerRef} className={styles['popover']}>
                        <div className={styles['cover']} onClick={handleClose} />
                        <SketchPicker
                            color={value}
                            onChange={handleColorChange}
                            disableAlpha={true}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default SketchColorPicker
